import { all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';
import RestApi from '../../helpers/api';

const api = new RestApi('companies/product-cards');

export function* load() {
  try {
    const response = yield api.load();

    if (response.status === 'success') {
      const { data, count = 0 } = response;

      yield put(
        actions.loadSuccess({
          data,
          count,
        }),
      );
    } else if (response.status === 'error') {
      const { error } = response.data;

      yield put(actions.loadError(error));
    }
  } catch (error) {
    console.warn(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, load)]);
}
